__turbopack_context__.v({
  "root": "Slider-module-scss-module__o8T6HG__root",
});
